module.exports = __webpack_public_path__ + "img/order_confirmation_icon.19519fc4.svg";